import AdminApi from '../services/api';
import swal from 'sweetalert2';

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'order'],

    data() {
        return {
            title: '',
            isLoading: false,
            selectedOrder: null,
            selectedVoucher: null,
            initialPayByCredit: false,
            payByCredit: false,
            newPrepTime: 0,
            newPrice: 0,
            newComment:'',
            customerPhoneNumber: null,
            oldGreenVoucher : 0,
            oldBlueVoucher : 0,
            oldWhiteVoucher : 0,
            greenVoucher : 0,
            blueVoucher : 0,
            whiteVoucher : 0,
            hasError: ''
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.selectedOrder = this.order;
                this.title = this.order.company.name;
                this.newPrepTime = this.order.preparationTime;
                this.newPrice = this.order.price;
                this.newComment = this.order.comment;
                this.customerPhoneNumber = this.order.customerPhoneNumber;
                this.detectVouchers(this.order);
                this.payByCredit = this.greenVoucher > 0;
                this.initialPayByCredit = this.greenVoucher > 0;
                if(this.greenVoucher > 0){
                    this.newPrice = this.greenVoucher;
                }
                // this.selectedVoucher = this.order.voucher;
            }
        },
        newPrepTime: function(val, oldVal) {
            this.hasError = '';
        },
        newPrice: function(val, oldVal) {
            this.hasError = '';
        },
        newComment: function(val, oldVal) {
            this.hasError = '';
        },
        payByCredit: function(val, oldVal) {
            this.hasError = '';
        },
    },

    methods: {
        close() {
            this.reset();
            this.$topnavbar.$emit('closeEdit')
        },
        successUpdate(order){
            this.reset();
            this.$topnavbar.$emit('successEdit',order)
        },

        updateDriver: updateDriver,
        detectVouchers: detectVouchers,
        generateVoucher: generateVoucher,
        plusVoucher: plusVoucher,
        minusVoucher: minusVoucher,
        checkChangeVouchersAndSendUpdate: checkChangeVouchersAndSendUpdate,
        setVoucher: setVoucher,
        getVoucherStyle: getVoucherStyle,
        reset: reset,
    }
}

function detectVouchers(order){
    var voucher = order.voucher;
    if(voucher == null || voucher.length === 0) return;
    var tempVouchers = voucher.split(";");
    tempVouchers.forEach(e => {
        var tempVoucher =  e.split("-");
        if(tempVoucher[0] === 'VOUCHER_GREEN'){
            this.greenVoucher = tempVoucher.length <= 1 ? 1 : parseInt(tempVoucher[1]);
            this.oldGreenVoucher = tempVoucher.length <= 1 ? 1 : parseInt(tempVoucher[1]);
        }
        if(tempVoucher[0] === 'VOUCHER_BLUE'){
            this.blueVoucher =  tempVoucher.length <= 1 ? 1 : parseInt(tempVoucher[1]);
            this.oldBlueVoucher = tempVoucher.length <= 1 ? 1 : parseInt(tempVoucher[1]);

        }
        if(tempVoucher[0] === 'VOUCHER_WHITE'){
            this.whiteVoucher = tempVoucher.length <= 1 ? 1 : parseInt(tempVoucher[1]);
            this.oldWhiteVoucher = tempVoucher.length <= 1 ? 1 : parseInt(tempVoucher[1]);
        }
    });
}

function updateDriver() {
    if(this.newPrice.length === 0 ||
        this.newPrepTime.length === 0 ) {
        this.hasError = "Molimo popunite cenu i vreme preuzimanja.";
        return;
    }
    if(this.selectedOrder.company.usingVouchers === false && this.payByCredit){
        this.hasError = "Kompanija ne koristi kredite. Plaćanje omogućeno jedino u dinarima.";
        return;
    }
    let _self =this;
    let order = _self.order;
    var newVoucher = _self.payByCredit ? "VOUCHER_GREEN-"+parseInt(_self.newPrice) : null;
    // if(newVoucher == null || newVoucher.length === 0 ){
    //     newVoucher = null;
    // }
    const newModel = {
        fromCompany: order.company.id,
        to: {
            city: order.address.city,
            country: order.address.country,
            street: order.address.street
        },
        preparationTime: _self.newPrepTime,
        courier: order.courier != null ? order.courier.id : null,
        price: newVoucher == null ? _self.newPrice : 0,
        comment: _self.newComment,
        status: order.status,
        orderPrice: order.orderPrice,
        customerPhoneNumber: _self.customerPhoneNumber,
        voucher: newVoucher
    };

    _self.isLoading = true;
    AdminApiService.updateOrder(newModel, order.id)
        .then((response) => {
            _self.checkChangeVouchersAndSendUpdate(order, response)
            // _self.reset();
            // _self.isLoading = false;
            // _self.successUpdate(response.data);
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom ažuriranja"
        })

}

function checkChangeVouchersAndSendUpdate(order, res){
    let _self = this;
    if(order.status !== 'DELIVERED'){
        _self.reset();
        _self.isLoading = false;
        _self.successUpdate(res.data);
    }else{
        if(_self.payByCredit !== _self.initialPayByCredit ){
        // if(_self.oldGreenVoucher !== _self.greenVoucher ||
        //     _self.oldBlueVoucher !== _self.blueVoucher ||
        //     _self.oldWhiteVoucher !== _self.whiteVoucher){
            var diffG = _self.initialPayByCredit ? _self.newPrice : -1 * _self.newPrice;
            // var greenM = _self.oldGreenVoucher > _self.greenVoucher ? 1 : -1
            // var greenB = _self.oldBlueVoucher > _self.blueVoucher ? 1 : -1
            // var greenW = _self.oldWhiteVoucher > _self.whiteVoucher ? 1 : -1
            // var diffG = greenM * (Math.abs(_self.oldGreenVoucher - _self.greenVoucher))
            // var diffB = greenB * (Math.abs(_self.oldBlueVoucher - _self.blueVoucher))
            // var diffW = greenW * (Math.abs(_self.oldWhiteVoucher - _self.whiteVoucher))

            const newModel = {
                blue: 0,
                green: diffG,
                white: 0
            };

            AdminApiService.addVoucherToOrder(order.id, newModel)
                .then((response) => {
                    _self.reset();
                    _self.isLoading = false;
                    _self.successUpdate(res);
                })
                .catch((error) => {
                    _self.reset();
                    _self.isLoading = false;
                    _self.hasError = "Greška desila se greska prilikom oduzimanja kupona od kompanije."
                })
            // swal('Greška', "Doslo je do promene kupona, salji zahtev za izmenu nad kompanijom", 'error')
        }else{
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate(res.data);
        }
    }
}

function generateVoucher() {
    var returnValue = "";
    if(this.greenVoucher > 0) returnValue += "VOUCHER_GREEN-"+this.greenVoucher+";";
    if(this.blueVoucher > 0) returnValue += "VOUCHER_BLUE-"+this.blueVoucher+";";
    if(this.whiteVoucher > 0) returnValue += "VOUCHER_WHITE-"+this.whiteVoucher+";";
    if(returnValue.isEmpty){
        return null;
    }else{
        return returnValue;
    }
}

function reset() {
    this.newPrice = 0;
    this.newPrepTime = 0;
    this.newComment = '';
    this.selectedVoucher = null;
    this.blueVoucher = 0;
    this.greenVoucher = 0;
    this.whiteVoucher = 0;
    this.oldBlueVoucher = 0;
    this.oldGreenVoucher = 0;
    this.oldWhiteVoucher = 0;
}

function setVoucher(voucher) {
    this.selectedVoucher = voucher;
}


function plusVoucher(voucher) {
    switch (voucher) {
        case 'VOUCHER_BLUE': {
            this.blueVoucher++;
            break;
        }
        case 'VOUCHER_GREEN': {
            this.greenVoucher++;
            break;
        }
        case 'VOUCHER_WHITE': {
            this.whiteVoucher++;
            break;
        }
    }
}

function minusVoucher(voucher) {
    switch (voucher) {
        case 'VOUCHER_BLUE': {
            if(this.blueVoucher > 0){
                this.blueVoucher--;
            }
            break;
        }
        case 'VOUCHER_GREEN': {
            if(this.greenVoucher > 0){
                this.greenVoucher--;
            }
            break;
        }
        case 'VOUCHER_WHITE': {
            if(this.whiteVoucher > 0){
                this.whiteVoucher--;
            }
            break;
        }
    }
}

function getVoucherStyle() {
    switch (this.selectedVoucher) {
        case 'VOUCHER_BLUE': return "width: 30px; height: 24px; background: cornflowerblue;";
        case 'VOUCHER_GREEN': return "width: 30px; height: 24px; background: forestgreen;";
        case 'VOUCHER_WHITE': return "width: 30px; height: 24px; background: white;";
        default : return "width: 0px; height: 0px;"
    }
}


// WEBPACK FOOTER //
// ./src/modals/EditOrderModal.js